import {
  STENCIL_SUBMISSION_SET_AUTHOR_NAME,
  STENCIL_SUBMISSION_SET_CAPTION_TEXT,
  STENCIL_SUBMISSION_SET_OPT_IN_NEWSLETTER,
  STENCIL_SUBMISSION_SET_REMOTE_PREVIEW_IMAGE_URL,
  STENCIL_SUBMISSION_SET_AUTHOR_EMAIL,
  STENCIL_SUBMISSION_SET_SHARE_WITH_OTHERS,
  STENCIL_SET_CURRENT_PAGE
} from '../../constants/stencil';

export interface SetAuthorEmailAction {
  type: typeof STENCIL_SUBMISSION_SET_AUTHOR_EMAIL;
  payload: string;
}

export function setAuthorEmail(email: string): SetAuthorEmailAction {
  return {
    type: STENCIL_SUBMISSION_SET_AUTHOR_EMAIL,
    payload: email
  };
}

export interface SetAuthorNameAction {
  type: typeof STENCIL_SUBMISSION_SET_AUTHOR_NAME;
  payload: string;
}

export function setAuthorName(name: string): SetAuthorNameAction {
  return {
    type: STENCIL_SUBMISSION_SET_AUTHOR_NAME,
    payload: name
  };
}

export interface SetCaptionTextAction {
  type: typeof STENCIL_SUBMISSION_SET_CAPTION_TEXT;
  payload: string;
}

export function setCaptionText(captionText: string): SetCaptionTextAction {
  return {
    type: STENCIL_SUBMISSION_SET_CAPTION_TEXT,
    payload: captionText
  };
}

export interface SetShareWithOthersAction {
  type: typeof STENCIL_SUBMISSION_SET_SHARE_WITH_OTHERS;
  payload: boolean;
}

export function setShareWithOthers(
  newValue: boolean
): SetShareWithOthersAction {
  return {
    type: STENCIL_SUBMISSION_SET_SHARE_WITH_OTHERS,
    payload: newValue
  };
}

export interface SetOptInNewsletterAction {
  type: typeof STENCIL_SUBMISSION_SET_OPT_IN_NEWSLETTER;
  payload: boolean;
}

export function setOptInNewsletter(
  newValue: boolean
): SetOptInNewsletterAction {
  return {
    type: STENCIL_SUBMISSION_SET_OPT_IN_NEWSLETTER,
    payload: newValue
  };
}

export interface SetRemotePreviewImageUrlAction {
  type: typeof STENCIL_SUBMISSION_SET_REMOTE_PREVIEW_IMAGE_URL;
  payload: string;
}

export function setRemotePreviewImageUrl(
  newValue: string
): SetRemotePreviewImageUrlAction {
  return {
    type: STENCIL_SUBMISSION_SET_REMOTE_PREVIEW_IMAGE_URL,
    payload: newValue
  };
}

export interface SetCurrentPageAction {
  type: typeof STENCIL_SET_CURRENT_PAGE;
  payload: 'build' | 'preview';
}

export function setCurrentPage(
  page: 'build' | 'preview'
): SetCurrentPageAction {
  return {
    type: STENCIL_SET_CURRENT_PAGE,
    payload: page
  };
}
